import cs from "classnames";
import React from "react";
import { getPrettyHours } from "@lululemon/dsp-utils";
import { CloseHourType, OpenHourType } from "@lululemon/dsp-shared";

import styles from "./store-hours.module.scss";

interface IStoreHoursProps {
  hours: {
    name: string;
    closeHour: CloseHourType;
    openHour: OpenHourType;
  }[];
  specialHours: {
    date: string;
    closeHour: CloseHourType;
    openHour: OpenHourType;
    description: string;
  }[];
  storeName: string;
  showModal: boolean;
  noPadding: boolean;
}

const StoreHours = ({
  hours = [],
  specialHours = []
}: IStoreHoursProps): React.ReactElement => {
  const prettyHours = getPrettyHours(hours, specialHours);

  const getHoursMessage = () => {
    return (
      prettyHours.todaysSpecialHours ||
      prettyHours.todaysRegularHours ||
      "Closed"
    );
  };

  return (
    <div className={styles.storeHoursContainer}>
      <div className={cs(styles.title, styles.padded)}>{getHoursMessage()}</div>
    </div>
  );
};

export default StoreHours;
